var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-container full-height" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            visible: _vm.dialogMemberFormVisible,
            title: _vm.roleSettingObj.id ? "編輯帳號" : "新增帳號",
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogMemberFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("el-alert", {
                            staticStyle: { color: "#4b4b4b" },
                            attrs: {
                              closable: false,
                              title:
                                "密碼為使用不可逆的加密演算法，無法查詢，只能設定新密碼",
                              type: "warning",
                              effect: "dark",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "memberForm",
                          attrs: {
                            rules: _vm.rules,
                            model: _vm.roleSettingObj,
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "負責國家區域",
                                prop: "countryAreaList",
                              },
                            },
                            [
                              _c("el-cascader", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "collapse-tags": "",
                                  props: {
                                    expandTrigger: "hover",
                                    multiple: true,
                                  },
                                  placeholder: "預設為全選",
                                  filterable: "",
                                  options: _vm.travelAttractionsMenu,
                                },
                                model: {
                                  value: _vm.roleSettingObj.countryAreaList,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.roleSettingObj,
                                      "countryAreaList",
                                      $$v
                                    )
                                  },
                                  expression: "roleSettingObj.countryAreaList",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "角色設定", prop: "role" } },
                            [
                              _vm.agencyRoleList &&
                              _vm.agencyRoleList.length > 0
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "請選擇" },
                                      model: {
                                        value: _vm.roleSettingObj.role,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.roleSettingObj,
                                            "role",
                                            $$v
                                          )
                                        },
                                        expression: "roleSettingObj.role",
                                      },
                                    },
                                    _vm._l(_vm.agencyRoleList, function (item) {
                                      return _c("el-option", {
                                        key: item.roleCode,
                                        attrs: {
                                          label: item.roleName,
                                          value: item.roleCode,
                                        },
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "帳號", prop: "account" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "帳號只限輸入英文小寫或數字",
                                },
                                model: {
                                  value: _vm.roleSettingObj.account,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.roleSettingObj, "account", $$v)
                                  },
                                  expression: "roleSettingObj.account",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "姓名", prop: "name" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "請輸入姓名" },
                                model: {
                                  value: _vm.roleSettingObj.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.roleSettingObj, "name", $$v)
                                  },
                                  expression: "roleSettingObj.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Email", prop: "mail" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "請輸入Email" },
                                model: {
                                  value: _vm.roleSettingObj.mail,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.roleSettingObj, "mail", $$v)
                                  },
                                  expression: "roleSettingObj.mail",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "狀態" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-text": "停用",
                                  "inactive-text": "啟用",
                                  "active-color": "#ff4949",
                                  "inactive-color": "#13ce66",
                                  "active-value": 0,
                                  "inactive-value": 1,
                                },
                                model: {
                                  value: _vm.roleSettingObj.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.roleSettingObj, "status", $$v)
                                  },
                                  expression: "roleSettingObj.status",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "密碼", prop: "pwd" } },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      staticStyle: {
                                        height: "auto",
                                        "white-space": "break-spaces",
                                        "font-size": "14px",
                                      },
                                      attrs: { type: "warning" },
                                    },
                                    [
                                      _vm._v(
                                        "密碼原則：密碼必須包含英文，數字及長度介於6-16之間"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm.roleSettingObj.id
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-bottom": "5px" },
                                      attrs: {
                                        type: _vm.showPwdInupt
                                          ? "danger"
                                          : "primary",
                                        size: "mini",
                                      },
                                      on: { click: _vm.showPwdInuptHandler },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showPwdInupt ? "取消" : "更改密碼"
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.roleSettingObj.id || _vm.showPwdInupt
                                ? _c("el-input", {
                                    attrs: { "show-password": "" },
                                    model: {
                                      value: _vm.roleSettingObj.pwd,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.roleSettingObj, "pwd", $$v)
                                      },
                                      expression: "roleSettingObj.pwd",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", [
                  _c("img", {
                    attrs: {
                      src: _vm.roleList,
                      alt: "roleList",
                      fit: "contain",
                      width: "100%",
                    },
                  }),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: {
                    click: function ($event) {
                      return _vm.saveData("memberForm")
                    },
                  },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogMemberFormVisible = !_vm.dialogMemberFormVisible
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入關鍵字" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.handleFilter($event)
                  },
                },
                model: {
                  value: _vm.listQuery.qry,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery, "qry", $$v)
                  },
                  expression: "listQuery.qry",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.handleFilter },
          }),
          _c("el-button", {
            attrs: {
              type: "warning",
              circle: "",
              icon: "el-icon-plus",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.addData },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              key: _vm.tableKey,
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "帳號",
                  prop: "account",
                  sortable: "custom",
                  align: "center",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.account))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "姓名",
                  prop: "name",
                  sortable: "custom",
                  align: "center",
                  width: "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.name))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "狀態" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.status == 0 ? "danger" : "success",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.status == 0 ? "停用" : "啟用")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "角色" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("roleStyle")(scope.row.role),
                            },
                          },
                          [_vm._v(_vm._s(_vm._f("roleDesc")(scope.row.role)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 編輯 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.checkPermission(["ITA-DEV", "ITA-TRAVEL-AGENCY"])
                ? _c("el-table-column", {
                    attrs: { align: "center", label: "刪除" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "filter-item",
                                  attrs: { size: "mini", type: "danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteMember(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" 刪除 ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4152774168
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }